/* eslint-disable */

import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Select,
  Text,
} from "@chakra-ui/react";
import sc from "states-cities-db";
import ReactCountryFlag from "react-country-flag";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { parsePhoneNumber } from "libphonenumber-js";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

interface PhoneNumberInputProps {
  id: string;
  value: string;
  onBlur?: any;
  placeholder?: string;
  label: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  visible: boolean;
  onChange: any;
  defaultValue?: any;
}

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = (props) => {
  const [selectedCountry, setSelectedCountry] = useState<string>("FR");
  const [number, setNumber] = useState("");
  const [prefix, setPrefix] = useState("+33");
  const [touched, setTouched] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    try {
      const parsedNumber = parsePhoneNumber(props.value);
      setNumber(parsedNumber.nationalNumber.toString());
      setPrefix(`+${parsePhoneNumber(props.value).countryCallingCode}`);
      if (parsedNumber.country) {
        setSelectedCountry(parsedNumber.country);
      }
    } catch (e) {
      // console.log(e);
    }
  }, [props.value]);

  const countriesList = sc.getCountries();

  const countryOptions = countriesList.map(
    ({ name, iso, iso2 }: { name: string; iso: string; iso2: string }) => ({
      label: name,
      key: iso,
      value: iso2,
    })
  );

  const onCountryChange = (e: any) => {
    const value = e.target.value;
    setSelectedCountry(value);
    const prefix = countriesList.find(
      ({ iso2 }: { iso2: string }) => iso2 === value
    ).prefix;
    setPrefix(prefix);
  };

  const isValid = () => {
    try {
      const parsedNumber = parsePhoneNumber(prefix + number);
      return parsedNumber.isValid();
    } catch {
      return false;
    }
  };

  const onBlur = () => {
    props.onBlur({
      id: props.id,
      type: "phone",
      value: prefix + number,
      valid: isValid(),
    });
  };

  const onPhoneNumberChange = (e: any) => {
    setTouched(true);
    const re = /^(\s*|\d+)$/;
    if (re.test(e.target.value)) {
      setNumber(e.target.value);
    }
    props.onChange(`${prefix}${e.target.value}`);
  };

  let rightElement;

  if (isValid()) {
    rightElement = (
      <InputRightElement>
        <CheckIcon color="green.500" />
      </InputRightElement>
    );
  } else if (props.isRequired && touched) {
    rightElement = (
      <InputRightElement>
        <CloseIcon color="red.500" />
      </InputRightElement>
    );
  }

  if (props.visible) {
    return (
      <>
        <FormControl
          mb={2}
          isRequired={props.isRequired}
          isDisabled={props.isDisabled}
        >
          <FormLabel> {t(props.label)}</FormLabel>
          <InputGroup>
            <InputLeftElement width="4rem">
              {props.isDisabled ? null : (
                <>
                  <Select
                    top="0"
                    left="0"
                    zIndex={1}
                    bottom={0}
                    opacity={0}
                    height="2.5rem"
                    position="absolute"
                    value={selectedCountry}
                    onChange={onCountryChange}
                    onBlur={onBlur}
                    ml="4.5rem"
                  >
                    <option value="" />
                    {countryOptions.map((option: any) => (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                  <Flex pl={2} width="100%" alignItems="center">
                    {selectedCountry ? (
                      <Box mr="4px" flex={1} p={2}>
                        <HStack>
                          <ReactCountryFlag
                            position="absolute"
                            countryCode={selectedCountry}
                          />
                          <Text>{prefix}</Text>
                        </HStack>
                      </Box>
                    ) : (
                      <FontAwesomeIcon icon={faPhone} />
                    )}
                  </Flex>
                </>
              )}
            </InputLeftElement>
            <Input
              color="#636E95"
              pl="9rem"
              type="tel"
              pattern="[0-9]"
              bg="brand.inputBackground"
              value={number}
              placeholder={props.placeholder}
              defaultValue={props.defaultValue}
              onBlur={onBlur}
              x
              onChange={onPhoneNumberChange}
              isDisabled={props.isDisabled}
            />
            {rightElement}
          </InputGroup>
        </FormControl>
      </>
    );
  } else {
    return null;
  }
};

export default PhoneNumberInput;
